import AddressManage from '@/views/Private/Pages/AddressManage'
import Selects from '@/views/Private/Pages/Selects'
import Home from '@/views/Private/Pages/Home'
import Orders from '@/views/Private/Pages/Orders'
import Requests from '@/views/Private/Pages/Requests'
import Users from '@/views/Private/Pages/Users'
import Settings from '@/views/Private/Pages/Settings'
import ProductSingle from '@/views/Private/Pages/ProductSingle'
import SavedItems from '@/views/Private/Pages/SavedItems'
import Share from '@/views/Private/Pages/Share'

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      permission: 'view-product'
    }
  },
  {
    path: '/addresses',
    name: 'addresses',
    component: AddressManage,
    meta: {
      role: ['admin'],
      label: 'Addresses'
    }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      role: ['admin', 'manager'],
      label: 'Users'
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      role: ['admin', 'manager'],
      label: 'Settings'
    }
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders,
    meta: {
      role: ['admin', 'manager'],
      label: 'All Orders'
    }
  },
  {
    path: '/history',
    name: 'history',
    component: Requests,
    meta: {
      role: ['admin', 'manager', 'designer'],
      label: 'My History'
    }
  },
  {
    path: '/selects',
    name: 'selects',
    component: Selects
  },
  {
    path: '/share/:hash',
    name: 'share',
    component: Share
  },
  {
    path: '/products',
    name: 'products',
    redirect: '/'
  },
  {
    path: '/saved-items',
    name: 'savedItems',
    component: SavedItems
  },
  {
    path: '/products/:id',
    component: ProductSingle,
    name: 'productSingle',
    meta: {
      permission: 'view-product'
    }
  }
]
